import { render, staticRenderFns } from "./orderCommodityData.vue?vue&type=template&id=4c19a5c6&scoped=true&"
import script from "./orderCommodityData.vue?vue&type=script&lang=js&"
export * from "./orderCommodityData.vue?vue&type=script&lang=js&"
import style0 from "./orderCommodityData.vue?vue&type=style&index=0&id=4c19a5c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c19a5c6",
  null
  
)

export default component.exports